export default __webpack_public_path__ + "static/media/david.007cef4c.png";